import PageTitle from "../Common/PageTitle"
import ToolBar from "../Common/Toolbar"
import { FC, Fragment, useEffect, useState } from "react"
import columns from "./columns"
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import MenuListPop from "../Common/menu"
import { DeleteOutlineOutlined, EditOutlined } from "@mui/icons-material"
import { ContactProps } from "../../types/contacts"
import { Apis } from "../../helpers"
import { PropertyProps } from "../../types/properties"
import NoData from "../Common/NoData"
import { useNavigate } from "react-router-dom"
import { Connect, mapStateToProps } from "../../Redux"
import DeleteModal from '../Common/deletePrompt'

interface StateProps {
    data: ContactProps[]
    loading: boolean
    showDeleteModal: null | ContactProps
    refreshing: boolean
    searchVal: string
}
interface Props {
    selectedProperty?: PropertyProps
}
const menuList = [
    { label: 'Edit', icon: <EditOutlined /> },
    { label: 'Delete', icon: <DeleteOutlineOutlined /> }
]
const Contacts: FC<Props> = ({
    selectedProperty
}) => {
    const [state, setState] = useState<StateProps>({
        data: [],
        showDeleteModal: null,
        loading: true,
        refreshing: false,
        searchVal: ''
    })
    const navigate = useNavigate()

    const { data, loading, showDeleteModal, refreshing, searchVal } = state

    const getPropertyContacts = ({
        refreshing
    }: any) => {
        if (refreshing)
            setState({ ...state, refreshing: true })
        Apis({
            module: 'Properties',
            action: 'getPropertyContacts',
            propertId: selectedProperty?._id
        }).then((data: any) => {
            setState({ ...state, data, loading: false, refreshing: false })
        }).catch(() => {
            setState({
                ...state,
                loading: false,
                refreshing: false
            })
        })
    }
    useEffect(() => {
        getPropertyContacts({})
        // eslint-disable-next-line
    }, [])

    const filteredData = data.filter(({ name, title }) =>
        !searchVal ||
        name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        title?.toLowerCase().includes(searchVal.toLowerCase())
    )

    return (
        <Box sx={{ height: '100%', pr: 5 }}>
            <PageTitle title={"Contacts"} />
            {!loading && data.length ?
                <ToolBar
                    addTitle={'Add Contact'}
                    addPage={'/new_contact'}
                    refreshing={refreshing}
                    onRefresh={() => getPropertyContacts({ refreshing: true })}
                    onSearch={(searchVal) => setState({ ...state, searchVal })}
                />
                : null}
            {
                !filteredData?.length || loading ?
                    <NoData
                        message={`You don't have any contacts.`}
                        createMessage={`Add Contact`}
                        onCreate={() => navigate('/new_contact')}
                        loading={loading}
                        searchVal={searchVal}
                    /> :
                    <Paper sx={{ width: '100%' }}>
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            columns.map(({ label }) => (
                                                <TableCell sx={{ fontWeight: 'bold' }} key={label}>
                                                    {label}
                                                </TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        filteredData.map((datam) => (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={datam._id}>
                                                {
                                                    columns.map(({ label, name }) => (
                                                        <TableCell key={label + '' + datam._id}>
                                                            {
                                                                name === 'action' ?
                                                                    <MenuListPop
                                                                        menuList={menuList}
                                                                        onSelect={option => {
                                                                            if (option === 'Edit')
                                                                                navigate('/new_contact', { state: { record: datam } })
                                                                            else if (option === 'Delete')
                                                                                setState({
                                                                                    ...state,
                                                                                    showDeleteModal: datam
                                                                                })
                                                                        }} /> :
                                                                    (datam as any)[name] || 'None'
                                                            }
                                                        </TableCell>
                                                    ))
                                                }
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
            }
            {
                showDeleteModal ?
                    <DeleteModal
                        item={showDeleteModal}
                        close={() => setState({ ...state, showDeleteModal: null })}
                        onDelete={() => {
                            const itemIndex = data?.findIndex(q => q._id === showDeleteModal?._id) as number
                            const Items = [...data]
                            Items?.splice(itemIndex, 1)
                            setState({
                                ...state,
                                showDeleteModal: null,
                                data: Items
                            })
                        }}
                        page='Contact'
                        module={'Properties'}
                        action={'addUpdateDeleteContact'}
                        itemName={showDeleteModal.name}
                        recordId={showDeleteModal._id}
                        propertyId={selectedProperty?._id}
                    /> :
                    <Fragment />
            }
        </Box>
    )
}

export default Connect(mapStateToProps)(Contacts)
